module.exports = __webpack_public_path__ + "img/white-tree-new.634d6533.png";